import { useState, useMemo, useEffect } from "react";

import {
  Box,
  Grid,
  Text,
  HStack,
  VStack,
  Heading,
  useToast,
  CircularProgress,
  Container,
  Breadcrumb,
  BreadcrumbItem,
  FormControl,
  FormHelperText,
  useDisclosure,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";
import { useHistory } from "react-router-dom";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import Input from "components/Input/Input";
import Select from "components/Select/Select";
import Button from "components/Button/Button";
import SuccessModal from "components/Modals/Success";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import {
  useRequestLoanMutation,
  useGetLoanableCoinsQuery,
  useGetApplicableLoanDurationQuery,
  useGetLoanProfileQuery,
  useGetApplicableLoanRatesQuery,
} from "services/walletApi";
import { useGetCoinToUsdRateQuery } from "services/rateApi";

import toPrecision from "util/toPrecision";
import toCoinLocale from "util/toCoinLocale";
import getError from "util/getError";

export default function RequestLoan(props) {
  const currentPage = "Home";
  const minimumLoan = 10;

  const toast = useToast();
  const history = useHistory();
  const [state, setState] = useState({});
  const { isOpen, onOpen, onClose } = useDisclosure();

  const coinValue = useMemo(() => {
    const map = {
      [state?.coin]: state?.coin,
      teth: "eth",
      tbtc: "btc",
    };
    return map[state?.coin ?? "tbtc"];
  }, [state?.coin]);

  const { data: rates, isFetching } = useGetCoinToUsdRateQuery(coinValue);

  const { data: loanProfile, isLoading: isProfiling } =
    useGetLoanProfileQuery();

  const isEligible = useMemo(
    () => loanProfile?.eligibility?.status,
    [loanProfile]
  );

  const { data: loanRateData } = useGetApplicableLoanRatesQuery();

  const loanRate = useMemo(
    () => loanRateData?.rate?.value ?? 0,
    [loanRateData]
  );

  console.log("LOAN PROFILE", loanProfile, loanRateData, loanRate);

  const { data: durationsData, isLoading: isFethcingDurations } =
    useGetApplicableLoanDurationQuery();

  const { data: loanableCoinsData, isLoading: isFethcingLoanables } =
    useGetLoanableCoinsQuery();

  const durations = useMemo(() => durationsData?.durations, [durationsData]);
  const loanables = useMemo(() => loanableCoinsData?.data, [loanableCoinsData]);

  const canMakeRequest = useMemo(
    () => isEligible,
    // loanProfile?.applicationsCount?.pending < 1 &&
    // loanProfile?.applicationsCount?.running < 1,
    [isEligible]
  );

  console.log("CAN MAKE REQUEST", canMakeRequest);

  // console.log("LOANABLES", loanableCoinsData);

  const [requestLoan, { data, isLoading, isSuccess, isError, error }] =
    useRequestLoanMutation();

  const handleState = (newState) => setState({ ...state, ...newState });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("FORM DATA", state);
    requestLoan({ ...state });
  };

  const handleClose = () => {
    onClose();
    setState({});
    history.replace("/dashboard/bcpl");
  };

  const loanLimit = useMemo(
    () => Number(loanProfile?.loanLimit ?? 50),
    [loanProfile]
  );

  const isAmountMoreThanLimit = useMemo(
    () => (+state?.currencyAmount ?? 0) > loanLimit,
    [state?.currencyAmount, loanLimit]
  );

  const isDisabled = useMemo(
    () =>
      !(state?.coin && state?.currencyAmount && state?.duration) ||
      isLoading ||
      Number(state?.currencyAmount ?? 0) > loanLimit ||
      Number(state?.currencyAmount ?? 0) < minimumLoan,
    [state, isLoading, loanLimit, minimumLoan]
  );

  const loanAmount = useMemo(
    () => state?.currencyAmount / rates?.exchangeRate?.buy,
    [rates, state?.currencyAmount]
  );

  const paybackAmount = useMemo(
    () => loanRate && +state?.currencyAmount * (1 + (loanRate ?? 10) / 100),
    [loanRate, state?.currencyAmount]
  );

  useEffect(() => {
    if (isSuccess && data) {
      onOpen();
    }

    if (isError && error) {
      console.log("REQUEST LOAN ERROR", error);
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, isError, data, error, onOpen, toast]);

  useEffect(() => {
    if (!isProfiling && !canMakeRequest) {
      history.replace("/dashboard/bcpl");
    }
  }, [canMakeRequest, history, isProfiling]);

  console.log("STATE", state, durationsData, loanProfile);

  console.log("CAN MAKE REQUEST", canMakeRequest);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="bcpl">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["24px", "0", "0"]}>
              <Heading fontSize="3xl">Request Loan</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/home">Home</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/bcpl">BCPL</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Request Loan
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Grid
              templateColumns={["1fr", "1fr", "repeat(2, 1fr)"]}
              mt="32px"
              gap="20px"
            >
              <Box
                bg="white"
                // border="1px solid #8688942f"
                // minH="681px"
                //   w="calc(100% - 25vw)"
                // w="fit-content"
                borderRadius="16px"
                shadow="0px 8px 24px rgba(154, 170, 207, 0.15)"
                p="48px"
              >
                <VStack as="form" onSubmit={handleSubmit}>
                  <FormControl>
                    <Select
                      isRequired
                      isLoading={isFethcingLoanables}
                      label="Coin Type"
                      value={state?.coin ?? ""}
                      onChange={(e) => handleState({ coin: e.target.value })}
                      placeholder="Select coin type"
                    >
                      {loanables?.map((item) => (
                        <option
                          key={`loanables-${item?.coin}`}
                          value={item?.coin}
                        >
                          {item?.label}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl mt="20px !important">
                    <Input
                      isRequired
                      label="Amount"
                      isInvalid={isAmountMoreThanLimit}
                      startAdornment={"$"}
                      value={state?.currencyAmount ?? ""}
                      onChange={(e) =>
                        handleState({ currencyAmount: e.target.value })
                      }
                    />
                    {Number(state?.currencyAmount ?? 0) > minimumLoan && (
                      <FormHelperText
                        fontSize="xs"
                        color={
                          loanLimit < Number(state?.currencyAmount ?? 0)
                            ? "red.400"
                            : "gray.500"
                        }
                      >
                        Maximum limit: {loanLimit} USD worth
                      </FormHelperText>
                    )}

                    {state?.currencyAmount &&
                      Number(state?.currencyAmount ?? 0) < minimumLoan && (
                        <FormHelperText fontSize="xs" color="red.400">
                          Minimum loan request: {minimumLoan} USD
                        </FormHelperText>
                      )}
                  </FormControl>

                  {state?.coin && (
                    <FormControl mt="20px !important">
                      <Input
                        label="You receive"
                        // defaultValue={loanAmount ?? ""}
                        value={
                          isNaN(toPrecision(loanAmount, state?.coin, false))
                            ? ""
                            : toPrecision(loanAmount, state?.coin, false)
                        }
                        disabled
                        endAdornment={toCoinLocale(state?.coin) ?? ""}
                      />
                      <FormHelperText fontSize="xs">
                        <HStack>
                          <Text>
                            Buy rate: $
                            {Number(rates?.exchangeRate?.buy).toLocaleString()}
                          </Text>

                          {isFetching && (
                            <CircularProgress
                              isIndeterminate
                              color="green.400"
                              size="12px"
                            />
                          )}
                        </HStack>
                      </FormHelperText>
                    </FormControl>
                  )}

                  <FormControl mt="20px !important">
                    <Select
                      isRequired
                      placeholder="Select duration"
                      label="Duration"
                      value={state?.duration ?? ""}
                      onChange={(e) =>
                        handleState({ duration: e.target.value })
                      }
                    >
                      {durations?.map((item) => (
                        <option
                          key={`duration-${item?.duration}`}
                          value={item?.duration}
                        >
                          {item?.label}
                        </option>
                      ))}
                    </Select>

                    <FormHelperText fontSize="xs">
                      <HStack>
                        <Text>Interest rate: {loanRate ?? 10}%</Text>

                        {isFethcingDurations && (
                          <CircularProgress
                            isIndeterminate
                            color="green.400"
                            size="12px"
                          />
                        )}
                      </HStack>
                    </FormHelperText>
                  </FormControl>

                  {state?.currencyAmount && (
                    <FormControl mt="20px !important">
                      <Input
                        label="You Pay"
                        // defaultValue={loanAmount ?? ""}
                        value={
                          isNaN(toPrecision(paybackAmount, state?.coin, false))
                            ? ""
                            : toPrecision(paybackAmount, state?.coin, false)
                        }
                        disabled
                        endAdornment={"USD"}
                      />
                    </FormControl>
                  )}

                  <Button
                    type="submit"
                    minW="100%"
                    minH="64px"
                    mt="40px !important"
                    disabled={isDisabled}
                    isLoading={isLoading}
                  >
                    Submit
                  </Button>
                </VStack>
              </Box>
            </Grid>
          </Container>
        </Box>
      </Box>

      <SuccessModal
        isOpen={isOpen}
        onClose={handleClose}
        title="Processing"
        message={`Your request is now been processed`}
      />
    </Box>
  );
}
